import { Component, EventEmitter, Injector, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import { AppComponentBase } from '@shared/app-component-base';
import { ConvenioDto, ConvenioServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-suspend-convenio',
  templateUrl: './suspend-convenio.component.html',
})
export class SuspendConvenioComponent extends AppComponentBase {
  public convenio: ConvenioDto = new ConvenioDto();
  public saving: boolean = false;
  @Output() onSave = new EventEmitter<any>();

  constructor(
    inject: Injector,
    private _convenioService: ConvenioServiceProxy,
    public bsModalRef: BsModalRef,
  ) { super(inject) }

  protected save(): void {
    this.saving = true;
    abp.ui.setBusy();
    this._convenioService.activeOrDeActivate(this.convenio.id).pipe(
      finalize(() => {
        abp.ui.clearBusy();
        this.saving = false;
      })
    ).subscribe((result) => {
      this.onSave.emit();
      this.bsModalRef.hide();
    })
  }
}
